import { fetchPlan } from './fetchPlan';
import { getAvailablePlansForCaller } from './getAvailablePlansForCaller';
import { fetchPlans } from './fetchPlans';
import { createPlan } from './createPlan';
import { updatePlan } from './updatePlan';
import { setDefaultPlanForKind } from './setDefaultPlanForKind';
import { deletePlan } from './deletePlan';
import { fetchAllPlanNames } from './fetchAllPlanNames';

export const planService = {
  getAvailablePlansForCaller,
  fetchAllPlanNames,
  fetchPlan,
  fetchPlans,
  createPlan,
  updatePlan,
  deletePlan,
  setDefaultPlanForKind,
};
